// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Geocoding_Types_StreetAddressWithApartment from "../Restaumatic.Geocoding.Types.StreetAddressWithApartment/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId);
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Geocoding_Types_StreetAddressWithApartment.eqStreetAddressWithApartm));
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var isIosReviewModeIsSymbol = {
    reflectSymbol: function () {
        return "isIosReviewMode";
    }
};
var isQrWaiterOrderIsSymbol = {
    reflectSymbol: function () {
        return "isQrWaiterOrder";
    }
};
var restaurantIdIsSymbol = {
    reflectSymbol: function () {
        return "restaurantId";
    }
};
var GetOrderingAvailabilityRequestIsSymbol = {
    reflectSymbol: function () {
        return "GetOrderingAvailabilityRequest";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId);
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var phoneIsSymbol = {
    reflectSymbol: function () {
        return "phone";
    }
};
var streetAddressIsSymbol = {
    reflectSymbol: function () {
        return "streetAddress";
    }
};
var ClaimFODRequestIsSymbol = {
    reflectSymbol: function () {
        return "ClaimFODRequest";
    }
};
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode);
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons1 = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons2 = /* #__PURE__ */ decodeRecordCons1(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode);
var decodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var GetOrderingAvailabilityRequest = function (x) {
    return x;
};
var ClaimFODRequest = function (x) {
    return x;
};
var toFillFormTypeGetOrdering = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeClaimFODReq = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesGetOrderingAvaila = {};
var rPCSitesClaimFODRequestBo = {};
var rPCMethodNameGetOrderingA = {
    rpcMethodName: function (v) {
        return "GetOrderingAvailabilityRequest";
    }
};
var rPCMethodNameClaimFODRequ = {
    rpcMethodName: function (v) {
        return "ClaimFODRequest";
    }
};
var newtypeGetOrderingAvailab = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeClaimFODRequest_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetOrderingAvaila = function (dictHasField) {
    return dictHasField;
};
var hasFieldClaimFODRequest = function (dictHasField) {
    return dictHasField;
};
var eqGetOrderingAvailability = {
    eq: function (x) {
        return function (y) {
            return x.isIosReviewMode === y.isIosReviewMode && x.isQrWaiterOrder === y.isQrWaiterOrder && eq1(x.restaurantId)(y.restaurantId);
        };
    }
};
var eqClaimFODRequest = {
    eq: function (x) {
        return function (y) {
            return x.email === y.email && x.phone === y.phone && eq1(x.restaurantId)(y.restaurantId) && eq3(x.streetAddress)(y.streetAddress);
        };
    }
};
var genericGetOrderingAvailabilityRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetOrderingAvailabilityRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(isIosReviewModeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(isQrWaiterOrderIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showBoolean))(Data_Show.showBoolean))))(GetOrderingAvailabilityRequestIsSymbol))
};
var unscrambleDecodeGetOrderingAvailabilityRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(isIosReviewModeIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(isQrWaiterOrderIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ decodeRecordCons(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericClaimFODRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showClaimFODRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericClaimFODRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(emailIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(phoneIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetAddressIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Geocoding_Types_StreetAddressWithApartment.showStreetAddressWithApartment)))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showString))(Data_Show.showString))))(ClaimFODRequestIsSymbol))
};
var unscrambleDecodeClaimFODRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericClaimFODRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(emailIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ Unscramble.decodeRecordCons(streetAddressIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Geocoding_Types_StreetAddressWithApartment.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodeGetOrderingAvailabilityRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(restaurantIdIsSymbol)(encodeWithOptionsOther))(isQrWaiterOrderIsSymbol)(encodeWithOptionsOther1))(isIosReviewModeIsSymbol)(encodeWithOptionsOther1)))))
};
var encodeClaimFODRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericClaimFODRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Geocoding_Types_StreetAddressWithApartment.encodeStreetAddressWithApartment))))(restaurantIdIsSymbol)(encodeWithOptionsOther))(phoneIsSymbol)(encodeWithOptionsOther2))(emailIsSymbol)(encodeWithOptionsOther2)))))
};
var decodeGetOrderingAvailabilityRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ decodeRecordCons2(restaurantIdIsSymbol)(decodeWithOptionsOther)())(isQrWaiterOrderIsSymbol)(decodeWithOptionsOther1)())(isIosReviewModeIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeClaimFODRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ decodeRecordCons2(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Geocoding_Types_StreetAddressWithApartment.decodeStreetAddressWithApartment)))())(restaurantIdIsSymbol)(decodeWithOptionsOther)())(phoneIsSymbol)(decodeWithOptionsOther2)())(emailIsSymbol)(decodeWithOptionsOther2)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GetOrderingAvailabilityRequest,
    ClaimFODRequest,
    genericGetOrderingAvailabilityRequest,
    eqGetOrderingAvailability,
    showGetOrderingAvailabilityRequest,
    rPCMethodNameGetOrderingA,
    rPCSitesGetOrderingAvaila,
    encodeGetOrderingAvailabilityRequest,
    decodeGetOrderingAvailabilityRequest,
    unscrambleDecodeGetOrderingAvailabilityRequest,
    toFillFormTypeGetOrdering,
    hasFieldGetOrderingAvaila,
    newtypeGetOrderingAvailab,
    genericClaimFODRequest,
    eqClaimFODRequest,
    showClaimFODRequest,
    rPCMethodNameClaimFODRequ,
    rPCSitesClaimFODRequestBo,
    encodeClaimFODRequest,
    decodeClaimFODRequest,
    unscrambleDecodeClaimFODRequest,
    toFillFormTypeClaimFODReq,
    hasFieldClaimFODRequest,
    newtypeClaimFODRequest_
};
